import { proxyClientOptions, RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { PromiseResponse } from '../entities';
import { OptionChainEnvironment } from '../environment';
import { optionChainRoutes } from './routes';
import { OptionChainTransport } from './types';

export class OptionChainRestful extends RestfulClient implements OptionChainTransport {
  constructor(session: Session) {
    const env = session.getEnvironment(OptionChainEnvironment);
    super(env.url, session, { 'x-device-key': true }, proxyClientOptions(undefined, 'apikey'));
  }

  getOptionChain = (symbols: string | string[]): SafePromise<PromiseResponse> => {
    const query = Array.isArray(symbols) ? symbols.join(',') : symbols;
    const env = this.session.getEnvironment(OptionChainEnvironment);
    const path = this.routePath(optionChainRoutes.optionChain);
    const url = this.URL(path, this.withUpstreamCredentials({ symbols: query }, { apikey: env.apiKey }));
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
